import { subscriptionService } from "@/api/SubscriptionService";
import { toast } from "sonner";


export const toggleSubscription = async (
  subscriptionId: string,
) => {

  await subscriptionService.cancelSubscriptionRenew(subscriptionId);
  return { subscriptionId };
};

export const getActiveSubscriptions = async () => {
  const response = await subscriptionService.getUserSubscriptions();
  if (!response) {
    return [];
  }
  return response.items;
};

export const getSubscriptionsHistory = async () => {
  const response = await subscriptionService.getUserSubscriptions();
  if (!response.items) {
    return [];
  }
  return response.items;
};

export const getAvailableSubscriptions = async () => {
  const response = await subscriptionService.getSubscriptions({
    nonActive: true,
    available: true,
  });

  if (!response.items) {
    return [];
  }
  return response.items;
};

export const cancelSubscriptionRenew = async (subscriptionId: string) => {
  const response = await subscriptionService.cancelSubscriptionRenew(
    subscriptionId,
  );
  return response;
};

export const restoreSubscription = async (subscriptionId: string) => {
  const response = await subscriptionService.restoreSubscription(subscriptionId);
  return response;
}

export const startWallet = (productId: string, returnUrl: string) => {
  if (productId) {
    subscriptionService
      .startAituWalletPayment(productId, returnUrl)
      .then((resp) => {
        window.location.href = resp.redirectUrl;
      })
      .catch((err) => {
        console.log(err);
        toast("Ошибка при вызове AituWallet", {
          description: err?.description,
          duration: 2000,
          richColors: true,
          position: "top-center",
        });
      });
  } else {
    toast("Подписка не выбрана", {
      description: "",
      duration: 2000,
      richColors: true,
      position: "top-center",
    });
  }
};
